import { JSX } from 'react'

import { IconProps } from '../../icon'

const BibliotecaNube: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 33 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_888_46)'>
      <path
        d='M16.0141 32C24.8507 32 32.0141 24.8366 32.0141 16C32.0141 7.16344 24.8507 0 16.0141 0C7.17754 0 0.0140991 7.16344 0.0140991 16C0.0140991 24.8366 7.17754 32 16.0141 32Z'
        fill='#BDEFF4'
      />
      <path
        d='M9.66089 4.31195H14.7985V26.3303H9.66089V4.31195Z'
        fill='#0096C7'
      />
      <path
        d='M13.6196 4.31195H14.8031V26.3303H13.6196V4.31195Z'
        fill='#007399'
      />
      <path
        d='M14.7985 4.31195H19.9361V26.3303H14.7985V4.31195Z'
        fill='#FFC55F'
      />
      <path
        d='M18.7572 4.31195H19.9407V26.3303H18.7572V4.31195Z'
        fill='#F8AD49'
      />
      <path
        d='M20.1013 5.89911L24.9866 4.31195L31.6242 24.7431L26.7389 26.3303L20.1013 5.89911Z'
        fill='#C63D4F'
      />
      <path
        d='M20.1058 5.89908L21.3352 5.5L27.9728 25.9312L26.7435 26.3303L20.1058 5.89908Z'
        fill='#AC3345'
      />
      <path
        d='M9.66089 6.51373H14.7985V7.94034H9.66089V6.51373Z'
        fill='white'
      />
      <path
        d='M14.7985 6.51373H19.9361V7.94034H14.7985V6.51373Z'
        fill='white'
      />
      <path
        d='M20.771 7.94037L25.6563 6.35321L26.0875 7.6789L21.2022 9.26605L20.771 7.94037Z'
        fill='white'
      />
      <path
        d='M9.66089 22.7018H14.7985V24.1284H9.66089V22.7018Z'
        fill='white'
      />
      <path
        d='M14.7985 22.7018H19.9361V24.1284H14.7985V22.7018Z'
        fill='white'
      />
      <path
        d='M25.6471 22.9679L30.5324 21.3762L30.9636 22.7018L26.0783 24.289L25.6471 22.9679Z'
        fill='white'
      />
      <path
        d='M9.66089 26.6881H19.9361C20.138 26.6881 20.3031 26.5229 20.3031 26.3211V7.71102L26.3902 26.445C26.4224 26.5367 26.4866 26.6147 26.5737 26.656C26.6242 26.6835 26.6792 26.6973 26.7389 26.6973C26.7756 26.6973 26.8169 26.6927 26.8535 26.6789L31.7435 25.0918C31.9361 25.0275 32.0416 24.8211 31.9774 24.6285L30.8765 21.2615L26.0049 6.24313L25.3398 4.19726C25.2756 4.0046 25.0691 3.89909 24.8765 3.96331L20.3031 5.44955V4.30276C20.3031 4.10093 20.138 3.93579 19.9361 3.93579H9.66089C9.45905 3.93579 9.29391 4.10093 9.29391 4.30276V26.3211C9.29391 26.5229 9.45905 26.6881 9.66089 26.6881ZM10.0279 8.30735H14.4315V22.3349H10.0279V8.30735ZM15.1655 8.30735H19.5691V22.3349H15.1655V8.30735ZM14.4315 23.0688V23.7523H10.0279V23.0688H14.4315ZM15.1655 23.0688H19.5691V23.7523H15.1655V23.0688ZM19.5691 7.57341H15.1655V6.86698H19.5691V7.57341ZM14.4315 7.57341H10.0279V6.86698H14.4315V7.57341ZM10.0279 24.4862H14.4315V25.9541H10.0279V24.4862ZM15.1655 25.9541V24.4862H19.5691V25.9541H15.1655ZM30.0691 21.1422L25.8811 22.5L21.6563 9.5046L25.849 8.14221L30.0691 21.1422ZM30.5049 22.4679L26.3123 23.8257L26.1104 23.2018L30.2985 21.8395L30.5049 22.4679ZM25.6242 7.44497L21.4361 8.80735L21.2297 8.17891L25.4178 6.81652L25.6242 7.44497ZM26.9774 25.867L26.5462 24.5229L30.7297 23.1606L31.1701 24.5046L26.9774 25.867ZM24.7526 4.77524L25.193 6.13763L21.0003 7.48625L20.5646 6.13763L24.7526 4.77524ZM19.5691 6.13763H15.1655V4.66974H19.5691V6.13763ZM14.4315 4.66974V6.13763H10.0279V4.66974H14.4315Z'
        fill='#0A1120'
      />
      <path
        d='M12.06 11.101C11.8581 11.101 11.693 11.2661 11.693 11.4679V19.1743C11.693 19.3762 11.8581 19.5413 12.06 19.5413C12.2618 19.5413 12.4269 19.3762 12.4269 19.1743V11.4679C12.4269 11.2661 12.2618 11.101 12.06 11.101Z'
        fill='#0A1120'
      />
      <path
        d='M17.1976 11.101C16.9958 11.101 16.8306 11.2661 16.8306 11.4679V19.1743C16.8306 19.3762 16.9958 19.5413 17.1976 19.5413C17.3994 19.5413 17.5646 19.3762 17.5646 19.1743V11.4679C17.5646 11.2661 17.3994 11.101 17.1976 11.101Z'
        fill='#0A1120'
      />
      <path
        d='M24.193 11.9129L26.5141 19.0643C26.5646 19.2202 26.7159 19.3257 26.8811 19.3165C26.9178 19.3165 26.959 19.312 26.9957 19.2982C27.1884 19.234 27.2939 19.0276 27.2297 18.8349L24.8902 11.6835C24.826 11.4909 24.6196 11.3854 24.4269 11.445C24.2343 11.5138 24.1288 11.7202 24.193 11.9129Z'
        fill='#0A1120'
      />
      <path
        d='M22.0921 17.4817C21.7572 17.4817 21.4178 17.5138 21.0921 17.5826C20.8444 16.3395 20.0416 15.2844 18.9086 14.711C17.7802 14.1376 16.4499 14.1147 15.3031 14.6468C14.2618 11.7844 11.1013 10.3028 8.23428 11.3441C5.3719 12.3853 3.89024 15.5459 4.93153 18.4129C2.42235 18.4863 0.440702 20.5642 0.4774 23.0734C0.514097 25.5826 2.55997 27.6009 5.06914 27.6009H22.0921C24.8857 27.6009 27.1517 25.3349 27.1517 22.5413C27.1517 19.7477 24.8857 17.4817 22.0921 17.4817Z'
        fill='white'
      />
      <path
        d='M22.0921 17.023C21.8719 17.023 21.6517 17.0367 21.4315 17.0643C20.8398 15.1285 19.0554 13.8074 17.0324 13.8028C16.5278 13.8028 16.0278 13.8854 15.5508 14.0505C14.3719 11.5046 11.5783 10.1193 8.83977 10.7202C6.09665 11.3257 4.14711 13.7569 4.14711 16.5597C4.14711 17.0459 4.20675 17.5276 4.32601 18C1.71592 18.3991 -0.151052 20.7386 0.0416082 23.3762C0.234269 26.0092 2.42234 28.0551 5.06454 28.0643H22.0875C25.1379 28.0643 27.6104 25.5918 27.6104 22.5413C27.6104 19.4909 25.1379 17.023 22.0921 17.023ZM22.0921 27.1422H5.06913C2.80308 27.1514 0.949865 25.3349 0.913168 23.0643C0.881058 20.7982 2.67922 18.9221 4.94528 18.867C5.09207 18.8624 5.22968 18.789 5.31225 18.6652C5.39482 18.5459 5.41776 18.3899 5.3673 18.2523C4.45445 15.6377 5.81225 12.7753 8.41317 11.8349C11.0141 10.8899 13.8948 12.2156 14.8673 14.8028C14.9132 14.9221 15.0049 15.0184 15.1242 15.0688C15.2434 15.1193 15.3765 15.1147 15.4912 15.0597C15.9728 14.8349 16.4957 14.7202 17.0278 14.7202C18.7801 14.7248 20.2847 15.9542 20.6334 17.6698C20.6838 17.9175 20.9269 18.0826 21.1746 18.0322C21.4728 17.9725 21.7801 17.9404 22.0875 17.9404C24.6288 17.9404 26.6884 20 26.6884 22.5413C26.693 25.0826 24.6334 27.1422 22.0921 27.1422Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_888_46'>
        <rect
          width='32'
          height='32'
          fill='white'
          transform='translate(0.0140991)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default BibliotecaNube
